import {AnyElement, MuWidget} from "mu-widget/lib/MuWidget";
import {focusFirstVisibleControl, onDOMChanges} from "./Utils";

export class UiModalContainer extends MuWidget {
	public static instance: UiModalContainer;

	beforeIndex() {
		this.container.classList.add('modal-b');
	}

	afterIndex() {
		UiModalContainer.instance = this;
		// @ts-ignore
		this.ui.modals = this.container;
		onDOMChanges(
			this.ui.modals,
			(ev) => setTimeout(
				() => this.updateModals(ev),
				1
			)
		)
		/* this.ui.modals.addEventListener(
			"DOMNodeRemoved",
			(ev) => setTimeout(
				() => this.updateModals(ev),
				1
			)
		); */
		this.updateModals();
	}

	public openModal<T>(
		widget: string,
		title: string | null = null,
		params: any = {},
		focusFirstInput = true
	): T {
		const el = document.createElement("div") as AnyElement;
		this.ui.modals.appendChild(el);
		this.updateModals();
		el.classList.add("modal-i");
		el.setAttribute("mu-widget", widget);
		if (title) el.innerHTML = `<div class="modal-title"><h2 mu-id="modalTitle"></h2><span class="close" mu-id="btCloseModal" mu-click="muRemoveSelf">×</span> </div>`;
		const w = this.muActivateWidget(el, {
			widget: widget,
			params: params, // JSON.stringify(params)
		}, params) as unknown as T;
		if (title) { // @ts-ignore
			w.ui.modalTitle.innerText = title;
		}
		if (focusFirstInput) {
			focusFirstVisibleControl(el as HTMLElement);
		}
		// @ts-ignore
		el.widget = w;
		// @ts-ignore
		setTimeout(() => w.container.scrollIntoView(), 200);

		return w;
	}


	public static open<T>(
		widget: string,
		title: string | null = null,
		params: any = {},
		focusFirstInput = true
	): T {
		return this.instance.openModal<T>(widget, title, params, focusFirstInput);
	}

	private updateModals(ev: any = null) {
		const isAny = this.ui.modals.children.length > 0;
		this.muVisible(isAny, 'modals');
		document.documentElement.style.overflow = isAny ? "hidden" : "";
	}
}